import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import qs from 'qs';

export const workApiUrl = '/Vacancies';
export const quizApiUrl = '/Quiz';
export const branchesApiUrl = '/Vacancies/branches';

const ApiUrls = {
  workApiUrl,
  branchesApiUrl,
  quizApiUrl
};

function GetSearchRequest(params) {
  return nzApiAxios
    .get(workApiUrl, {
      params,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((value) => value?.data);
}

function GetVacancy(slug) {
  return nzApiAxios.get(`${workApiUrl}/${slug}`).then((value) => value?.data);
}

function GetTagsRequest() {
  return nzApiAxios.get(workApiUrl + '/tags').then((value) => value?.data);
}

const GetBranches = () => nzApiAxios.get(ApiUrls.branchesApiUrl).then((response) => response?.data);
const GetQuiz = (data) => nzApiAxios.get(ApiUrls.quizApiUrl, { params: data }).then((response) => response?.data);

const PostQuizRusult = (data) => nzApiAxios.post(ApiUrls.quizApiUrl, data).then((response) => response?.data);

const API = {
  search: GetSearchRequest,
  getVacancy: GetVacancy,
  getTags: GetTagsRequest,
  getBranches: GetBranches,
  getQuestions: GetQuiz,
  checkQuiz: PostQuizRusult
};

export { ApiUrls };
export default API;
